import { AdminMembersReportPageStartDate } from "@/admin/insights/member-reports/AdminMembersReportPage"
import AdminMembersReportCustomProfileFieldsTable from "@/admin/insights/member-reports/tabs/overview/AdminMembersReportCustomProfileFieldsTable"
import AdminMembersReportDailyTimeSpentSection from "@/admin/insights/member-reports/tabs/overview/AdminMembersReportDailyTimeSpentSection"
import AdminMembersReportOverviewTabStatisticsCards from "@/admin/insights/member-reports/tabs/overview/AdminMembersReportOverviewTabStatisticsCards"
import AdminMembersProfileFieldsTableExportCSVButton from "@/admin/insights/member-reports/tabs/overview/AdminMembersReportProfileFieldsTableExportCSVButton"
import AdminMembersReportStandardProfileFieldsTable from "@/admin/insights/member-reports/tabs/overview/AdminMembersReportStandardProfileFieldsTable"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoText } from "@disco-ui"

interface AdminMembersReportPageOverviewTabProps {
  startDate: AdminMembersReportPageStartDate
}

function AdminMembersReportPageOverviewTab({
  startDate,
}: AdminMembersReportPageOverviewTabProps) {
  const classes = useStyles()
  return (
    <>
      <AdminMembersReportOverviewTabStatisticsCards filters={{ startDate }} />
      <AdminMembersReportDailyTimeSpentSection filters={{ startDate }} />

      <div className={classes.profileFieldsHeader}>
        <DiscoText variant={"heading-xs-600"}>{"Member Profile"}</DiscoText>
        <AdminMembersProfileFieldsTableExportCSVButton />
      </div>
      <AdminMembersReportStandardProfileFieldsTable />
      <AdminMembersReportCustomProfileFieldsTable />
    </>
  )
}

const useStyles = makeUseStyles({
  profileFieldsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
})

export default AdminMembersReportPageOverviewTab
